import { StoreType } from '../redux/store';
import { convertModuleWithStore } from './routes.helper';
import { BlogsEditorPath } from 'app-constants';
  
export const getEditorRoutes = (store: StoreType) => (
{
  path: `/${BlogsEditorPath}/:page?`,
  lazy: async () => convertModuleWithStore(await import('./blogs-editor/root'), store),
  children: [
    {
      path: "new/blog/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/new.blog.splat'), store),
    },
    {
      path: "new/blog",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/new.blog.splat'), store),
    },
    {
      path: "new/posts/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/new.posts.splat'), store),
    },
    {
      path: "new/:editorType/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/new.editorType.splat'), store),
    },
    {
      path: "upload/blog/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/upload.blog.splat'), store),
    },
    {
      path: "edit/posts/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/edit.posts.splat'), store),
    },
    {
      path: "edit/meta/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/edit.meta.splat'), store),
    },
    {
      path: "edit/drawio/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/edit.drawio.splat'), store),
    },
    {
      path: "edit/puml/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/edit.puml.splat'), store),
    },
    {
      path: "view/meta/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/view.meta.splat'), store),
    },
    {
      path: "edit/image/*",
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/edit.image.splat'), store),
    },
    {
      index: true,
      lazy: async () => convertModuleWithStore(await import('./blogs-editor/_index'), store),
    }
  ]
});